

















































































































































































































































import {Component, Vue} from 'vue-property-decorator';
import Page, {EMPTY_PAGE} from "@/dto/taxation/Page";
import {
	ServiceInvoice,
	ServiceInvoiceFilter, ServiceRecordDTO,
	UpdateInvoicePayload
} from "@/components/payroll/business/services/ServiceDTO";
import ServiceInvoiceOrchestrator from "@/services/ServiceInvoiceOrchestrator";
import {processError} from "@/utils/ComponentUtils";
import Application from "@/state/Application";
import InvoiceCreationSlider from "@/components/payroll/business/services/invoice/InvoiceCreationSlider.vue";
import EmbeddedFile from "@/components/common/EmbeddedFile.vue";
import BTPortalCollapse from "@/components/common/BTPortalCollapse.vue";
import moment from "moment";
import {prettyEnum, subSrtIfNeed} from "../../../../../utils/StringUtils";
import SingleFileHolder from "@/components/util/SingleFileHolder.vue";
import ServiceLogView from "@/components/payroll/business/services/ServiceLogView.vue";
import ServiceInvoiceItem from "@/components/payroll/business/services/ServiceInvoiceItem.vue";
import DraftInvoicePreparer from "@/components/payroll/business/services/invoice/DraftInvoicePreparer.vue";
import PaginationComponent from "@/components/util/PaginationComponent.vue";
import ServiceLogUpdateSlider from "@/components/payroll/business/services/service/ServiceLogUpdateSlider.vue";
import ServiceLogViewSlider from "@/components/payroll/business/services/service/ServiceLogViewSlider.vue";

@Component({
	methods: {prettyEnum, subSrtIfNeed},
	components: {
		ServiceLogViewSlider,
		ServiceLogUpdateSlider,
		PaginationComponent,
		DraftInvoicePreparer,
		ServiceInvoiceItem,
		ServiceLogView, SingleFileHolder, BTPortalCollapse, EmbeddedFile, InvoiceCreationSlider}
})
export default class InvoiceList extends Vue {

	private draftInvoices: Page<ServiceInvoice> = EMPTY_PAGE
	private invoices: Page<ServiceInvoice> = EMPTY_PAGE

	private createInvoice = false;
	private draftInvoice = false
	private updateLog = false;
	private viewLog = false;

	private selectedInvoice: ServiceInvoice | null = null;
	private selectedLog: ServiceRecordDTO | null = null;

	private filter = new ServiceInvoiceFilter(
		{
			participantId: this.$wss.getCurrent.id
		}
	)

	openDraft(inv: ServiceInvoice) {
		this.selectedInvoice = inv
		this.draftInvoice = true
	}

	mounted() {
		Application.startLoading()
		Promise.all([this.loadInvoices(), this.loadDraftInvoices()])
			.finally(Application.stopLoading)
	}

	findInvoices() {
		Application.startLoading()
		Promise.all([this.loadInvoices(), this.loadDraftInvoices()])
			.finally(Application.stopLoading)
	}

	loadInvoices() {
		let filter = new ServiceInvoiceFilter(this.filter)
		filter.excludeStatus = "DRAFT"
		return ServiceInvoiceOrchestrator.getPageByFilter(filter).then(
			res => {
				this.invoices = res.data
			},
			err => processError(err, this)
		)
	}

	loadDraftInvoices() {
		let filter = new ServiceInvoiceFilter(this.filter)
		filter.status = "DRAFT"
		filter.payeeId = filter.participantId
		filter.participantId = null
		filter.page = 0
		filter.size = 5
		return ServiceInvoiceOrchestrator.getPageByFilter(filter).then(
			res => {
				this.draftInvoices = res.data
			},
			err => processError(err, this)
		)
	}

	private formatPeriod(inv: ServiceInvoice) {
		if (inv.startDate && inv.endDate) {
			return moment(inv.startDate).format("MMMM Do") + " - " + moment(inv.endDate).format("MMMM Do")
		} else {
			return "Custom period"
		}
	}

	private resolveStatusColor(inv: ServiceInvoice) {
		switch (inv.status) {
			case "DRAFT": return "#818181"
			case "IN_PROGRESS": return "#007bff"
			case "PAID": return "#28a745"
			case "VOIDED": return "#dc3545"
		}
	}

	private loadPage(page: number) {
		this.filter.page = page - 1
		this.findInvoices()
	}

	private loadNextPage() {
		this.filter.page = this.filter.page + 1
		this.findInvoices()
	}

	private voidInvoice(inv: ServiceInvoice) {
		Application.startLoading()
		ServiceInvoiceOrchestrator.changeStatus(
			new UpdateInvoicePayload(
				{
					serviceInvoiceId: inv.id,
					payeeId: inv.payee.id,
					payerId: inv.payer.id,
					status: 'VOIDED'
				}
			)
		).then(
			() => {
				this.findInvoices()
			},
			err => processError(err, this)
		).finally(() => Application.stopLoading())
	}

	private completeInvoice(inv: ServiceInvoice) {
		Application.startLoading()
		ServiceInvoiceOrchestrator.changeStatus(
			new UpdateInvoicePayload(
				{
					serviceInvoiceId: inv.id,
					payeeId: inv.payee.id,
					payerId: inv.payer.id,
					status: 'PAID'
				}
			)
		).then(
			() => {
				this.findInvoices()
			},
			err => processError(err, this)
		).finally(() => Application.stopLoading())
	}

	private resolveInvoiceTitle(invoice: ServiceInvoice) {
		if (invoice.payer.userId == this.$wss.getCurrent.userId) {
			return "From: " + invoice.payee.name
		} else {
			return invoice.payer.name
		}
	}

	private openLog(log: ServiceRecordDTO) {
		this.selectedLog = log
		if (log.executor.userId == this.$wss.getCurrent.userId) {
			this.updateLog = true;
		} else {
			this.viewLog = true;
		}
	}

}
